import dayjs from 'dayjs';
import { sanitizeHtml } from '../../../utils/useSanitize';
import { formatDateTimeWithTime } from '../../../utils/dateformatter';
import { formatDate } from '../../../utils/format';
import {
  productTypeEntriesFromDetail,
  productTypeEntriesToPayload,
} from './productTypes';

export const FORM_INITIAL_STATE = {
  procurementNumber: '',
  statusProcurement: '',
  titleProcurement: '',
  description: '',
  procurementType: '',
  contractType: '',
  contractPeriodSpot: '',
  contractPeriodTermStart: '',
  contractPeriodTermEnd: '',
  productTypeId: '',
  productType: '',
  procurementProductTypes: [],
  partyType: '',
  productName: '',
  productNameId: '',
  operationalTolerance: '',
  productSpecification: '',
  ratioLpgId: '',
  ratioLpg: '',
  refPropaneFrequency: null,
  refPropaneRangeQuantityFrom: null,
  refPropaneRangeQuantityTo: null,
  refButaneFrequency: null,
  refButaneRangeQuantityFrom: null,
  refButaneRangeQuantityTo: null,
  notesForQuantityAndDeliveryTerms: '',
  globalNotes: '',
  invoicingQuantityId: '',
  invoicingQuantity: '',
  modeInvoicingQuantityId: '',
  modeInvoicingQuantity: '',
  delayPenaltyAmount: null,
  descriptionOfDelayPenaltyTerms: '',
  descriptionOfPaymentTerms: '',
  paymentCurrencyId: '',
  paymentCurrency: '',
  lawId: '',
  law: '',
  arbitrationId: '',
  arbitration: '',
  notesForLoadingPort: '',
  portRestriction: [],
  otherTermsAndCondition: '',
  additionalNotes: '',
  proposalSubmissionDeadline: '',
  proposalValidityPeriodMax: '',
  fileHasilOptimasiHilir: '',
  filePenetapanHargaDasarImpor: '',
  fileSpesifikasi: '',
  fileGeneralTermsAndConditions: '',
  fileDocumentQ88: '',
  fileDocumentGasFormC: '',
  fileSupporting1: '',
  fileSupporting2: '',
  fileSupporting3: '',
  fileSupporting4: '',
  fileSupporting5: '',
  subStatus: '',
  procurementMitra: [],
  isQuantityDiscrepancyMandatory: '',
  isDeliveryMandatory: '',
  isNominationProcedureMandatory: '',
  isFirstTimeSupplyMandatory: '',
  isRedChannelPolicyMandatory: '',
  isDeliveryCustomMandatory: '',
  isInformationAboutDMUTConfirmed: '',
  isAcknowledgedDMUT: '',
  hpsRequestNumber: '',
  hpsRequestDate: '',
  userId: '',
  user: '',
  isProcurementRequirementCompleted: '',
  isSupportingDocumentsCompleted: '',
  isDMUTInvitationCompleted: '',
  isHPSRequestCompleted: '',
  isGtcCompleted: '',
  isInviteDMUTCompleted: '',
  isProcurementCompleted: '',
  // null = not loaded; the save then leaves the stored GTC untouched.
  gtcIds: null,
  gtcs: [],
  id: '',
  createdBy: '',
  updatedBy: '',
  createdDate: '',
  updatedDate: '',
  isDeleted: '',
  deletedDate: '',
  deletedBy: '',
  isFullCargoVLGC: false,
  fullCargoVLGCFrequency: null,
  fullCargoVLGCRefrigratePropaneMin: null,
  fullCargoVLGCRefrigratePropaneMax: null,
  fullCargoVLGCRefrigrateButaneMin: null,
  fullCargoVLGCRefrigrateButaneMax: null,
  isHalfCargoVLGC: false,
  halfCargoVLGCFrequency: null,
  halfCargoVLGCRefrigratePropaneMin: null,
  halfCargoVLGCRefrigratePropaneMax: null,
  halfCargoVLGCRefrigrateButaneMin: null,
  halfCargoVLGCRefrigrateButaneMax: null,
  isSemiRefrigerated: false,
  semiRefrigeratedFrequency: null,
  semiRefrigeratedRefrigratePropaneMin: null,
  semiRefrigeratedRefrigratePropaneMax: null,
  semiRefrigeratedRefrigrateButaneMin: null,
  semiRefrigeratedRefrigrateButaneMax: null,
  fullCargoVLGCQuantityStep: null,
  halfCargoVLGCQuantityStep: null,
  semiRefrigeratedQuantityStep: null,
  compositionQuantityStep: null,
  cargoType: null,
  compositionMin: null,
  compositionMax: null,
};

export function denormalizeProcurementDetail(form, dataCause) {
  return {
    contractType: form.contractType,
    contractPeriodSpot: form.contractPeriodSpot,
    contractPeriodTermStart: form.contractPeriodTermStart,
    contractPeriodTermEnd: form.contractPeriodTermEnd,
    productTypeId: form.productTypeId,
    partyType: form.partyType,
    operationalTolerance: form.operationalTolerance,
    productSpecification: form.productSpecification,
    ratioLpgId: form.ratioLpgId,
    refPropaneFrequency: form.refPropaneFrequency,
    refPropaneRangeQuantityFrom: form.refPropaneRangeQuantityFrom,
    refPropaneRangeQuantityTo: form.refPropaneRangeQuantityTo,
    refButaneFrequency: form.refButaneFrequency,
    refButaneRangeQuantityFrom: form.refButaneRangeQuantityFrom,
    refButaneRangeQuantityTo: form.refButaneRangeQuantityTo,
    notesForQuantityAndDeliveryTerms: form.notesForQuantityAndDeliveryTerms,
    globalNotes: form.globalNotes,
    invoicingQuantityId: form.invoicingQuantityId,
    modeInvoicingQuantityId: form.modeInvoicingQuantityId,
    // Input disabled: procurement baru tetap null, nilai legacy dipertahankan.
    delayPenaltyAmount:
      form.delayPenaltyAmount == null || form.delayPenaltyAmount === ''
        ? null
        : Number(form.delayPenaltyAmount),
    descriptionOfDelayPenaltyTerms: form.descriptionOfDelayPenaltyTerms,
    descriptionOfPaymentTerms: form.descriptionOfPaymentTerms,
    paymentCurrencyId: form.paymentCurrencyId,
    lawId: form.lawId,
    arbitrationId: form.arbitrationId,
    notesForLoadingPort: form.notesForLoadingPort,
    otherTermsAndCondition: form.otherTermsAndCondition,
    additionalNotes: form.additionalNotes,
    proposalSubmissionDeadline: form.proposalSubmissionDeadline,
    proposalValidityPeriodMax: form.proposalValidityPeriodMax,
    fileHasilOptimasiHilir: form.fileHasilOptimasiHilir,
    filePenetapanHargaDasarImpor: form.filePenetapanHargaDasarImpor,
    fileSpesifikasi: form.fileSpesifikasi,
    fileGeneralTermsAndConditions: form.fileGeneralTermsAndConditions,
    fileDocumentQ88: form.fileDocumentQ88,
    fileDocumentGasFormC: form.fileDocumentGasFormC,
    fileSupporting1: form.fileSupporting1,
    fileSupporting2: form.fileSupporting2,
    fileSupporting3: form.fileSupporting3,
    fileSupporting4: form.fileSupporting4,
    fileSupporting5: form.fileSupporting5,
    subStatus: form.subStatus,
    isQuantityDiscrepancyMandatory: form.isQuantityDiscrepancyMandatory,
    isDeliveryMandatory: form.isDeliveryMandatory,
    isNominationProcedureMandatory: form.isNominationProcedureMandatory,
    isFirstTimeSupplyMandatory: form.isFirstTimeSupplyMandatory,
    isRedChannelPolicyMandatory: form.isRedChannelPolicyMandatory,
    isDeliveryCustomMandatory: form.isDeliveryCustomMandatory,
    isInformationAboutDMUTConfirmed: form.isInformationAboutDMUTConfirmed,
    isAcknowledgedDMUT: form.isAcknowledgedDMUT,
    hpsRequestDate: form.hpsRequestDate,
    userId: form.userId,
    isProcurementRequirementCompleted: form.isProcurementRequirementCompleted,
    isSupportingDocumentsCompleted: form.isSupportingDocumentsCompleted,
    isDMUTInvitationCompleted: form.isDMUTInvitationCompleted,
    isHPSRequestCompleted: form.isHPSRequestCompleted,
    isFullCargoVLGC: form.isFullCargoVLGC,
    fullCargoVLGCFrequency: form.fullCargoVLGCFrequency,
    fullCargoVLGCRefrigratePropaneMin: form.fullCargoVLGCRefrigratePropaneMin,
    fullCargoVLGCRefrigratePropaneMax: form.fullCargoVLGCRefrigratePropaneMax,
    fullCargoVLGCRefrigrateButaneMin: form.fullCargoVLGCRefrigrateButaneMin,
    fullCargoVLGCRefrigrateButaneMax: form.fullCargoVLGCRefrigrateButaneMax,
    isHalfCargoVLGC: form.isHalfCargoVLGC,
    halfCargoVLGCFrequency: form.halfCargoVLGCFrequency,
    halfCargoVLGCRefrigratePropaneMin: form.halfCargoVLGCRefrigratePropaneMin,
    halfCargoVLGCRefrigratePropaneMax: form.halfCargoVLGCRefrigratePropaneMax,
    halfCargoVLGCRefrigrateButaneMin: form.halfCargoVLGCRefrigrateButaneMin,
    halfCargoVLGCRefrigrateButaneMax: form.halfCargoVLGCRefrigrateButaneMax,
    isSemiRefrigerated: form.isSemiRefrigerated,
    semiRefrigeratedFrequency: form.semiRefrigeratedFrequency,
    semiRefrigeratedRefrigratePropaneMin:
      form.semiRefrigeratedRefrigratePropaneMin,
    semiRefrigeratedRefrigratePropaneMax:
      form.semiRefrigeratedRefrigratePropaneMax,
    semiRefrigeratedRefrigrateButaneMin:
      form.semiRefrigeratedRefrigrateButaneMin,
    semiRefrigeratedRefrigrateButaneMax:
      form.semiRefrigeratedRefrigrateButaneMax,
    fullCargoVLGCQuantityStep: form.fullCargoVLGCQuantityStep,
    halfCargoVLGCQuantityStep: form.halfCargoVLGCQuantityStep,
    semiRefrigeratedQuantityStep: form.semiRefrigeratedQuantityStep,
    compositionQuantityStep: form.compositionQuantityStep,
    cargoType: form.cargoType,
    compositionMin: form.compositionMin,
    compositionMax: form.compositionMax,
    procurementClauseDetails: dataCause.procurementClauseDetails,
    // null leaves the stored product types untouched
    procurementProductTypes: form.procurementProductTypes?.length
      ? productTypeEntriesToPayload(form.procurementProductTypes)
      : null,
    procurementMitra: form.procurementMitra,
    ...(form.gtcIds != null && { gtcIds: form.gtcIds }),
  };
}

// One clause row of the Requirement tab (dataCause.items). isActive is the
// per-procurement switch; an older API without it falls back to the master
// clause's isShow, which is what decided visibility before.
export const toClauseItem = item => ({
  id: item.id ?? null,
  procurementId: item.procurementId ?? null,
  clauseDetailId: item.clauseDetailId ?? null,
  clauseTitle: item.clauseTitle ?? null,
  ordreNumber: item.ordreNumber ?? null,
  isShow: item.isShow ?? null,
  isActive: item.isActive ?? item.isShow === true,
  clauseDescription: item.clauseDescription ?? null,
  isShowToDMUT: item.isShowToDMUT ?? null,
});

export function normalizeProcurementDetail(data) {
  return {
    procurementNumber: data.procurementNumber || null,
    statusProcurement: data.statusProcurement ?? null,
    titleProcurement: data.titleProcurement || null,
    description: data.description || null,
    procurementType: data.procurementType || null,
    contractType: data.contractType ?? null,
    contractPeriodSpot: data.contractPeriodSpot ?? null,
    contractPeriodTermStart: data.contractPeriodTermStart || null,
    contractPeriodTermEnd: data.contractPeriodTermEnd || null,
    productTypeId: data.productTypeId || null,
    partyType: data.partyType || null,
    productType: data.productType || null,
    procurementProductTypes: productTypeEntriesFromDetail(data),
    productName: data.productType?.product?.name || null,
    productNameId: data.productType?.product?.id || null,
    operationalTolerance: data.operationalTolerance ?? null,
    productSpecification: sanitizeHtml(data.productSpecification) || null,
    ratioLpgId: null,
    ratioLpg: null,
    refPropaneFrequency: data.refPropaneFrequency ?? null,
    refPropaneRangeQuantityFrom: data.refPropaneRangeQuantityFrom ?? null,
    refPropaneRangeQuantityTo: data.refPropaneRangeQuantityTo ?? null,
    refButaneFrequency: data.refButaneFrequency ?? null,
    refButaneRangeQuantityFrom: data.refButaneRangeQuantityFrom ?? null,
    refButaneRangeQuantityTo: data.refButaneRangeQuantityTo ?? null,
    notesForQuantityAndDeliveryTerms:
      data.notesForQuantityAndDeliveryTerms || null,
    globalNotes: sanitizeHtml(data.globalNotes) || null,
    invoicingQuantityId: data.invoicingQuantityId || null,
    invoicingQuantity: null,
    modeInvoicingQuantityId: data.modeInvoicingQuantityId || null,
    modeInvoicingQuantity: data.modeInvoicingQuantity || null,
    delayPenaltyAmount: data.delayPenaltyAmount ?? null,
    descriptionOfDelayPenaltyTerms:
      sanitizeHtml(data.descriptionOfDelayPenaltyTerms) || null,
    descriptionOfPaymentTerms:
      sanitizeHtml(data.descriptionOfPaymentTerms) || null,
    paymentCurrencyId: data.paymentCurrencyId || null,
    paymentCurrency: data.paymentCurrency || null,
    lawId: data.lawId || null,
    law: data.law || null,
    arbitrationId: data.arbitrationId || null,
    arbitration: data.arbitration || null,
    notesForLoadingPort: data.notesForLoadingPort || null,
    portRestriction: data.portRestriction || [],
    otherTermsAndCondition: data.otherTermsAndCondition || null,
    additionalNotes: sanitizeHtml(data.additionalNotes) || null,
    proposalSubmissionDeadline: data.proposalSubmissionDeadline
      ? dayjs(data.proposalSubmissionDeadline).toDate()
      : null,
    proposalValidityPeriodMax: data.proposalValidityPeriodMax
      ? dayjs(data.proposalValidityPeriodMax).toDate()
      : null,
    fileHasilOptimasiHilir: null,
    filePenetapanHargaDasarImpor: null,
    fileSpesifikasi: null,
    fileGeneralTermsAndConditions: null,
    fileDocumentQ88: null,
    fileDocumentGasFormC: null,
    fileSupporting1: null,
    fileSupporting2: null,
    fileSupporting3: null,
    fileSupporting4: null,
    fileSupporting5: null,
    subStatus: data.subStatus || null,
    procurementMitra: data.procurementMitra || [],
    isQuantityDiscrepancyMandatory: null,
    isDeliveryMandatory: null,
    isNominationProcedureMandatory: null,
    isFirstTimeSupplyMandatory: null,
    isRedChannelPolicyMandatory: null,
    isDeliveryCustomMandatory: null,
    isInformationAboutDMUTConfirmed:
      data.isInformationAboutDMUTConfirmed ?? null,
    isAcknowledgedDMUT: data.isAcknowledgedDMUT ?? null,
    hpsRequestNumber: data.hpsRequestNumber || null,
    hpsRequestDate: data.hpsRequestDate || null,
    userId: data.userIdamanId || null,
    user: data.userIdaman || null,
    isProcurementRequirementCompleted:
      data.isProcurementRequirementCompleted ?? null,
    isSupportingDocumentsCompleted: data.isSupportingDocumentsCompleted ?? null,
    isDMUTInvitationCompleted: data.isDMUTInvitationCompleted ?? null,
    isHPSRequestCompleted: data.isHPSRequestCompleted ?? null,
    isGtcCompleted: data.isGtcCompleted ?? null,
    isInviteDMUTCompleted: data.isInviteDMUTCompleted ?? null,
    gtcs: data.gtcs || [],
    gtcIds: Array.isArray(data.gtcs) ? data.gtcs.map(gtc => gtc.id) : null,
    isProcurementCompleted: data.isProcurementCompleted ?? false,
    id: data.id || null,
    createdBy: data.createdBy || null,
    updatedBy: data.updatedBy || null,
    createdDate: formatDateTimeWithTime(data.createdDate) || null,
    updatedDate: data.updatedDate || null,
    isDeleted: data.isDeleted ?? null,
    deletedDate: data.deletedDate || null,
    deletedBy: data.deletedBy || null,
    procurementTypeHeaderLabel: data.procurementTypeHeaderLabel || null,

    isFullCargoVLGC: data.isFullCargoVLGC ?? false,
    fullCargoVLGCFrequency: data.fullCargoVLGCFrequency ?? null,
    fullCargoVLGCRefrigratePropaneMin:
      data.fullCargoVLGCRefrigratePropaneMin ?? null,
    fullCargoVLGCRefrigratePropaneMax:
      data.fullCargoVLGCRefrigratePropaneMax ?? null,
    fullCargoVLGCRefrigrateButaneMin:
      data.fullCargoVLGCRefrigrateButaneMin ?? null,
    fullCargoVLGCRefrigrateButaneMax:
      data.fullCargoVLGCRefrigrateButaneMax ?? null,
    isHalfCargoVLGC: data.isHalfCargoVLGC ?? false,
    halfCargoVLGCFrequency: data.halfCargoVLGCFrequency ?? null,
    halfCargoVLGCRefrigratePropaneMin:
      data.halfCargoVLGCRefrigratePropaneMin ?? null,
    halfCargoVLGCRefrigratePropaneMax:
      data.halfCargoVLGCRefrigratePropaneMax ?? null,
    halfCargoVLGCRefrigrateButaneMin:
      data.halfCargoVLGCRefrigrateButaneMin ?? null,
    halfCargoVLGCRefrigrateButaneMax:
      data.halfCargoVLGCRefrigrateButaneMax ?? null,
    isSemiRefrigerated: data.isSemiRefrigerated ?? false,
    semiRefrigeratedFrequency: data.semiRefrigeratedFrequency ?? null,
    semiRefrigeratedRefrigratePropaneMin:
      data.semiRefrigeratedRefrigratePropaneMin ?? null,
    semiRefrigeratedRefrigratePropaneMax:
      data.semiRefrigeratedRefrigratePropaneMax ?? null,
    semiRefrigeratedRefrigrateButaneMin:
      data.semiRefrigeratedRefrigrateButaneMin ?? null,
    semiRefrigeratedRefrigrateButaneMax:
      data.semiRefrigeratedRefrigrateButaneMax ?? null,
    fullCargoVLGCQuantityStep: data.fullCargoVLGCQuantityStep ?? null,
    halfCargoVLGCQuantityStep: data.halfCargoVLGCQuantityStep ?? null,
    semiRefrigeratedQuantityStep: data.semiRefrigeratedQuantityStep ?? null,
    compositionQuantityStep: data.compositionQuantityStep ?? null,
    cargoType: data.cargoType ?? null,
    compositionMin: data.compositionMin ?? null,
    compositionMax: data.compositionMax ?? null,
  };
}

export const displayValue = value => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

export const formatSubmittedDate = formatDate;

export const PROCUREMENT_TYPE_LABELS = {
  PelelanganKhusus: 'Pelelangan Khusus',
  PemilihanLangsung: 'Pemilihan Langsung',
  TunjukLangsung: 'Tunjuk Langsung',
};

// Rich-text editors leave '<br>' behind when cleared, so treat it as empty.
export const isBlankValue = value =>
  value === null ||
  value === undefined ||
  value === '' ||
  value === '<br>' ||
  (typeof value === 'string' && value.trim() === '');

const isTrue = value => value === true || value === 'true' || value === 1;

// Steps of the procurement detail page. `tab` is the TabPane id used by
// ProcurementForm; `flag` is the completion flag returned by the API.
export const PROCUREMENT_STEPS = [
  {
    tab: 1,
    label: 'Requirement',
    hint: 'Contract, product, delivery and terms',
    icon: 'ri-file-list-3-line',
    flag: 'isProcurementRequirementCompleted',
  },
  {
    tab: 2,
    label: 'Supporting Documents',
    hint: 'Files shared with suppliers',
    icon: 'ri-file-text-line',
    flag: 'isSupportingDocumentsCompleted',
  },
  {
    tab: 4,
    label: 'GTC',
    hint: 'General Terms & Conditions',
    icon: 'ri-scales-3-line',
    flag: 'isGtcCompleted',
  },
  {
    tab: 3,
    label: 'Supplier Invitation',
    hint: 'Who receives the tender',
    icon: 'ri-mail-send-line',
    flag: 'isDMUTInvitationCompleted',
  },
  {
    tab: 5,
    label: 'Review & Submit',
    hint: 'Check and submit',
    icon: 'ri-file-check-line',
    flag: 'isProcurementCompleted',
  },
];

// Every step except the final Review & Submit.
export const PROCUREMENT_WORK_STEPS = PROCUREMENT_STEPS.slice(0, -1);

export const isStepCompleted = (form, step) => isTrue(form?.[step.flag]);

// Draft: at least one work step is open. Ready: every work step is complete
// but not submitted yet. Submitted: locked.
export const getProcurementStage = form => {
  if (form?.isProcurementCompleted === true) {
    return { key: 'submitted', label: 'Submitted', tone: 'success' };
  }
  if (PROCUREMENT_WORK_STEPS.every(step => isStepCompleted(form, step))) {
    return { key: 'ready', label: 'Ready to submit', tone: 'info' };
  }
  return { key: 'draft', label: 'Draft', tone: 'warning' };
};

export const getProcurementStatusConfig = status => {
  const statusCode =
    status === '' || status === null || status === undefined
      ? 0
      : Number(status);

  switch (statusCode) {
    case 1:
      return {
        label: 'Submitted',
        tone: 'success',
        className: 'bg-success text-light',
      };
    case 0:
    default:
      return {
        label: 'Draft',
        tone: 'warning',
        className: 'bg-info text-light',
      };
  }
};
